import React from 'react';
import { useTranslation } from 'react-i18next';
import {v4 as uuidv4} from 'uuid';
import { useEffect } from 'react';
import { useCookies } from 'react-cookie';
import { Swiper, SwiperSlide } from 'swiper/react';
import { FreeMode, Pagination, Navigation } from 'swiper/modules';
import { useLocation } from "react-router-dom";

import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import Paper from '@mui/material/Paper';
import Input from '@mui/material/Input';
import InputAdornment from '@mui/material/InputAdornment';
import FormControl from '@mui/material/FormControl';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import Slider from '@mui/material/Slider';

import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';

import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import ReceiptIcon from '@mui/icons-material/Receipt';
import InfoIcon from '@mui/icons-material/Info';
import SendIcon from '@mui/icons-material/Send';
import RestartAltIcon from '@mui/icons-material/RestartAlt';
import Avatar from '@mui/material/Avatar';

import Header from "./common/Header2";
import ReimoSwiper from "../components/ReimoSwiper";

import Alert from "../dialogs/Alert";
import DisplayImage from "../dialogs/DisplayProductImage";
import RequestOffer from "../dialogs/RequestOffer";
import RequestConfig from "../dialogs/RequestConfig";

import ContactPersons from "../widgets/ContactPersons";
import ModelCard from "../widgets/ModelCard";
import ModelCardOwnConfig from "../widgets/ModelCardOwnConfig";
import ModelProductCard from "../widgets/ModelProductCard";
import ModelDesignCard from "../widgets/ModelDesignCard";
import ProductRoofCard from "../widgets/ProductRoofCard";
import BaseCarCard from "../widgets/BaseCarCard";

import articles from '../db/articles.json';


import {formatNumber, getExternal, calcMonth, getConfigurationCode, calcTotal} from "../helper/utils";

import 'swiper/css';
import 'swiper/css/free-mode';
import 'swiper/css/pagination';

const newConfig =  await getConfigurationCode();


function  ConfigureContent(props) {

	var models = require('../db/models.json');	
  	const getCar = (which) => {
		let car;
		models.cars.forEach((value, keys) => {
			if(value.url == which)
		  		car = value;
	  })
	  return car;
  	};


	let model = getCar(props.props.model);



	const prepareConfig = () => {	
		let configStore = [];
		
		for (const [key, value] of Object.entries(model.configuration)) {
			let o = {};				
			o.label = key;		
			let v = [];				
			value.forEach((value1, k1) => {
				let o1 = {};				
				let v1 = [];
				let myuuid = uuidv4();
				if(value1.default)
					v1.push(value1.default);				
				value1.uuid = myuuid;
				o1.label = value1.label;
				o1.uuid = myuuid;
				o1.id = value1.id;
				o1.widget = value1.widget;
				o1.items = v1;
				v.push(o1);
	
		  	})
			o.cluster = v;
			configStore.push(o);
	
		}	
		return configStore;
	}		
	
	const { t, i18n } = useTranslation("",{lng: props.language});

	const [internalConfiguration, setInternalConfiguration] = React.useState(prepareConfig);
	const [displayAlert, setDisplayAlert] = React.useState(false);
	const [displayImage, setDisplayImage] = React.useState(false);
	const [item, setItem] = React.useState(null);
	const [displayAlertMsg, setDisplayAlertMsg] = React.useState("");
	const [activeStep, setActiveStep] = React.useState(0);
	const [extCode, setExtCode] = React.useState("");
	const [externalConfiguration, setExternalConfiguration] = React.useState(null);
  	const [skipped, setSkipped] = React.useState(new Set());
	const [furnitureDecor, setFurnitureDecor] = React.useState("roof_option_12.jpg");
	const [basePlate, setBasePlate] = React.useState("roof_option_12.jpg");
	const [carFinal, setCarFinal] = React.useState(model.imagePlain);
	const [currentRoof, setCurrentRoof] = React.useState("");
	const [currentPad, setCurrentPad] = React.useState("");
	const [currentFloor, setCurrentFloor] = React.useState("");
	const [whichConfiguration, setWhichConfiguration] = React.useState("internal");
	const [currentReimoOptions, setCurrentReimoOptions] = React.useState(new Map());
	const [carPrice, setCarPrice] = React.useState(0);
	const [carArtnr, setCarArtnr] = React.useState("");
	
  	const [config, setConfig] = React.useState(newConfig.result);
	const [requestOffer, setRequestOffer] = React.useState(false);
	const [requestConfig, setRequestConfig] = React.useState(false);
	const [userConfig, setUserConfig] = React.useState();
  	const [openBD, setOpenBD] = React.useState(false);

	const [duration, setDuration] = React.useState(120);
	const [downPayment, setDownPayment] = React.useState(25);
	const [cookies, setCookie] = useCookies(['config']);

	const steps = [t("Grund Fahrzeug"),  t("Sonderausstattungen"), t("Schlafdach"), t("Zubehör"), t("Innen Design"), t("Zusammenfassung")];


    const location = useLocation();
    const configData = location.state?.configData;




	useEffect(() => {
	    if (configData) {
			model.engines.map(engine  => {
				if(engine.configCode == configData.engineId) {
					setWhichConfiguration("internal");
					setCarPrice(engine.price);					
					setCarArtnr(engine.configCode);						
					
				}
			
			});
			let sC1 = structuredClone(internalConfiguration);
			
			sC1[0].cluster[0].items = [];				
			configData.configuration.extras.forEach((v, k) => {
				sC1[0].cluster[0].items.push(v);
			});
					
			sC1[0].cluster[1].items = [];	
			configData.configuration.color.forEach((v, k) => {
				sC1[0].cluster[1].items.push(v);
			});		
					
			sC1[1].cluster[0].items = [];	
			configData.configuration.roof.forEach((v, k) => {
				sC1[1].cluster[0].items.push(v);
			});		
					
			sC1[1].cluster[1].items = [];	
			configData.configuration.roofExtras.forEach((v, k) => {
				sC1[1].cluster[1].items.push(v);
			});		
				
			sC1[2].cluster[0].items = [];	
			configData.configuration.equipment.forEach((v, k) => {
				sC1[2].cluster[0].items.push(v);
			});			
				
			sC1[3].cluster[0].items = [];	
			configData.configuration.decor.forEach((v, k) => {
				sC1[3].cluster[0].items.push(v);
			});			
			console.log("sC1");
			console.log(sC1);
			console.log("sC1Ende");
			setInternalConfiguration(sC1);
	        setActiveStep(1);
	    }
	}, [configData]); 


  	const handleChangeDuration = (event, newValue, activeThumb) => {
		setDuration(newValue);
  	};

  	const handleChangeDownPayment = (event, newValue, activeThumb) => {
		setDownPayment(newValue);
  	};

  	const handleCloseBD = () => {
    	setOpenBD(false);
  	};
  	
  	const handleOpenBD = () => {
    	setOpenBD(true);
  	}; 




	const callUrl = (url) => {
		if(url == "requestOffer")
			setRequestOffer(true);
		if(url == "requestConfig") {
		    // Initialisierung der Zielstruktur (Excel-Format)
		    let obj = {
		        carId: props.props.model, 
		        engineId: carArtnr,
		        docType: "KundenAngebot",
		        docNumber: config,
		        salesPerson: "",
		        discountBasis: model.discount,
		        discountReimo: 0.0,
		        downPaymentPercent: 15.0,
		        downPaymentManual: 0.0,
		        fairRabattPercent: 0.0,
		        fairRabattManual: 0.0,
		        fairRabattLabel: "",
		        configuration: {
		            extras: [],
		            roof: [],
		            equipment: [],
		            decor: [],
		            color: [],
		            roofExtras: []
		        }
		    };
		
		    // Wir mappen die flache internalConfiguration auf unsere Ziel-Keys
		    internalConfiguration.forEach(section => {
		        section.cluster.forEach(cluster => {
		            
		            switch(cluster.id) {
		                case 'carExtras':
		                    obj.configuration.extras = cluster.items;
		                    break;
		                case 'exteriorColor':
		                    obj.configuration.color = cluster.items;
		                    break;
		                case 'roof': 
		                    obj.configuration.roof = cluster.items;
		                    break;
		                case 'roofExtension': 
		                    obj.configuration.roofExtras = cluster.items;
		                    break;
		                case 'equipment': 
		                    obj.configuration.equipment = cluster.items;
		                    break;
		                case 'furnitureDecor': 
		                    obj.configuration.decor = cluster.items;
		                    break;
		            }
		        });
		    });
			setUserConfig(obj);
			setRequestConfig(true);
		}
	};
	
	const handleItem = (e, uuid, id) => {

		let sC = structuredClone(internalConfiguration);
		sC.forEach((v, k) => {		
			v.cluster.forEach((v1, k1) => {						
				if(v1.uuid == uuid) {
					if(v1.widget == "mandatorySingleChoice" || v1.widget == "mandatorySingleChoiceProductCard" || v1.widget == "mandatorySingleChoiceColor") {
						let oo = [];
						oo.push(id);					
						v1.items = oo

					}
					if(v1.widget == "singleChoice" || v1.widget == "singleChoiceColor"  || v1.widget == "singlechoiceProductCard"  || v1.widget == "singlechoiceRoofCard") {
						let oo = [];
						if(e.target.checked === true)
							oo.push(id);					
						v1.items = oo
					}
					
					if(v1.widget == "multiChoice" || v1.widget == "multiChoiceProductCard") {
						if(e.target.checked === true)
							v1.items.push(id);					
						else {
							let oo = [];
							v1.items.forEach((v2, k2) => {
								if(v2 != id)
									oo.push(v2);
							});						
							v1.items = oo
						}										
					}
				}
			});
		});

		setInternalConfiguration(sC);
	};


	const isStepOptional = (step) => {
	    return step === 19;
	  };

  	const isStepSkipped = (step) => {
    	return skipped.has(step);
  	};
  	
  	async function getNewCode() {
		const newConfig =  await getConfigurationCode();
		setConfig(newConfig.result);
	 };
  	

  	const handleNext = () => {
		setCookie('config', config);
    	let newSkipped = skipped;
    	if (isStepSkipped(activeStep)) {
      		newSkipped = new Set(newSkipped.values());
      		newSkipped.delete(activeStep);
    	}

		if(activeStep == 0 && whichConfiguration == "") {
			setDisplayAlert(true);
			setDisplayAlertMsg("Sie müssen ein Fahrzeug auswählen");
		}
		else {
			window.scrollTo(0, 0);
			getNewCode();

	    	setActiveStep((prevActiveStep) => prevActiveStep + 1);
	    	setSkipped(newSkipped);
	    }
  	};

  	const handleImageDisplay = (item) => {
		setItem(item);
    	setDisplayImage(true)
 	};

  	const handleBack = () => {
    	setActiveStep((prevActiveStep) => prevActiveStep - 1);
		window.scrollTo(0, 0);
  	};

  	const handleSkip = () => {
    	if (!isStepOptional(activeStep)) {
      		throw new Error("You can't skip a step that isn't optional.");
    	}

    	setActiveStep((prevActiveStep) => prevActiveStep + 1);
    	setSkipped((prevSkipped) => {
      		const newSkipped = new Set(prevSkipped.values());
      		newSkipped.add(activeStep);
      		return newSkipped;
    	});
  	};

  	const handleReset = () => {
		window.scrollTo(0, 0);
    	setActiveStep(0);
  	};
  	

  	const changeCarColorFloor = (carImage) => {
		setCarFinal(carImage);
  	};

  	const changeReimoOption = (e, reimoOption) => {
	  	var tmp = new Map(currentReimoOptions);
		if((tmp.has(reimoOption.artnr)))
			tmp.delete(reimoOption.artnr);
		else
			tmp.set(reimoOption.artnr, reimoOption);
		setCurrentReimoOptions(tmp);
  	};

  	const changeFloor = (e, carFloor) => {
		if(e.target.checked == false) {
			setCurrentFloor("");			
		}
		else {
			setCurrentFloor(carFloor);			
		}
  	};
  	
  	const changePad = (e, carPad) => {
		if(e.target.checked == false) {
			setCurrentPad("");			
		}
		else {
			setCurrentPad(carPad);			
		}
  	};

  	
  	const changeConfiguration = (e, which, extCode, producer, model) => {
		if(which == "internal") {
			setWhichConfiguration("internal");
			setCarPrice(model.price);					
			setCarArtnr(model.configCode);					
		}
		setWhichConfiguration(which);
		handleNext();
	};

  	function printReimoOption(value) {
		return (<Stack className="leftSpacing" direction="row" justifyContent="space-between" alignItems="center">
		        	<Typography gutterBottom variant="h6" component="div">
		            	{value.label}
		          	</Typography>
		          	<Typography gutterBottom variant="h6" component="div">
			            {formatNumber("de_DE", value.price)}
		          	</Typography>
		        </Stack>)
	}

  	function calcReimoAddonPrice() {
		let treimoAddonPrice = 0;
		if(currentRoof != "")
			treimoAddonPrice = Number(currentRoof.price);
		for (const [key, value] of currentReimoOptions) { 
		    if(!isNaN(value.price))
		    	treimoAddonPrice += Number(value.price);	
		}
		return treimoAddonPrice;
	}
  	
  	function printReimoOptions() {
		let html = [];
		for (const [key, value] of currentReimoOptions) { 
		    html.push( printReimoOption(value));
		}
		return html;
	}
  	
  	function widgetFactory(obj) {
		if(obj.widget == "singleChoice" || obj.widget == "mandatorySingleChoice")
			return renderSingleChoice(obj);	
		else if(obj.widget == "singleChoiceColor"  || obj.widget == "mandatorySingleChoiceColor")
			return renderSingleChoiceColor(obj);	
		else if(obj.widget == "multiChoice")
			return renderSingleChoice(obj);	
		else if(obj.widget == "singlechoiceProductCard" || obj.widget == "mandatorySingleChoiceProductCard" || obj.widget == "multiChoiceProductCard")
			return returnSinglechoiceProductCard(obj);	
			
	}
		
	function isChecked(uuid, id) {
		let checked = false;
		internalConfiguration.forEach((v, k) => {		
			v.cluster.forEach((v1, k1) => {						
				if(v1.uuid == uuid) {
					v1.items.forEach((v2, k2) => {
						if(v2 == id)
							checked = true;
					});						
				}
			});
		});		
		return checked;
	}

  	function renderSingleChoice (obj) {
		return 	<>	
					<h3 data-id={obj.id}>{obj.label}</h3>
						{obj.items.map((item)  => (
					        <Stack  className="leftSpacing1" direction="row" justifyContent="space-between" alignItems="center">
								<Typography style={{paddingLeft: "10px"}} gutterBottom variant="h6" component="div">
									<FormControlLabel
									  label={articles[item.refId].label}
									  control={
										<Checkbox 	data-type="carRoofs" 
													onClick={e => handleItem(e, obj.uuid, item.refId)}
													checked={isChecked(obj.uuid, item.refId)}
										/>	
									}
								/>
								{articles[item.refId].src != null ? (
									<>
										<span onClick={e => handleImageDisplay(articles[item.refId])}><InfoIcon /></span>
									</>) :
									(<></>)
								}
								</Typography>
							    <Typography gutterBottom variant="h6" component="div">
								   	<nobr>{formatNumber("de_DE", articles[item.refId].price)}</nobr>
					          	</Typography>																			          
							</Stack>	
						))}
				</>
	}
	
  	function returnSpecialValue (id, type) {
		let result = "";
		try {
			internalConfiguration[id].cluster.forEach((v1, k) => {
				if(v1.id == type) {		
					v1.items.forEach((v2, k2) => {
						 result = articles[v2].src;
					});						
				}
			});
		}
		catch (error) {
		}		
		return result;
	}

  	function renderSingleChoiceColor (obj) {
		return 	<>	
					<h3 data-id={obj.id}>{obj.label}</h3>
						{obj.items.map((item)  => (
							<>
			        		<Grid item xs={12} sx={{marginTop: "10px"}}>
					      		<Grid container spacing={2}>
					        		<Grid item xs={2}>
										<Avatar sx={{width: "48px", height: "48px", border: "1px solid #000", backgroundColor: "#fff"}} alt={articles[item.refId].label} src={"/assets/article-images/" + articles[item.refId].src} />
									</Grid>
					        		<Grid item xs={10}>							
								        <Stack className="leftSpacing1" direction="row" justifyContent="space-between" alignItems="center">
											<Typography gutterBottom variant="h6" component="div">						        	
												<FormControlLabel
												  label={articles[item.refId].label}
												  control={
													<Checkbox 	data-type="carRoofs" 
																onClick={e => handleItem(e, obj.uuid, item.refId)}
																checked={isChecked(obj.uuid, item.refId)}
													/>	
												}
											/>
											</Typography>
										    <Typography gutterBottom variant="h6" component="div">
											   	<nobr>{formatNumber("de_DE", articles[item.refId].price)}</nobr>
								          	</Typography>																			          
										</Stack>	
									</Grid>
								</Grid>
							</Grid>
							
							</>
						))}
				</>
	}

  	function returnSinglechoiceProductCard (obj) {
		return 	<>	
					<h3 data-id={obj.id}>{obj.label}</h3>
					<Grid container spacing={2}>
							{obj.items.map((item)  => (
								<Grid item xs={12} sm={12} md={6} lg={6} xl={4}>
									<ModelDesignCard 	item={articles[item.refId]} 
														changeItem={handleItem} 
														uuid={obj.uuid} 
														currentArtnr={item.refId} 
														checked={isChecked(obj.uuid, item.refId)}/>																		  
								</Grid>
							))}
					</Grid>	
				</>
	}

	function calcCluster(id) {
		let sum = Number(0);
		try {
			internalConfiguration[id].cluster.forEach((v1, k) => {		
					v1.items.forEach((v2, k2) => {
						sum += Number(articles[v2].price);
					});						
			});
		}
		catch (error) {
		}		
		return Number(sum);
	};

	function renderCluster(id) {
		return 	<>	
				{internalConfiguration[id].cluster.map((cluster)  => (
					<>
						{cluster.items.length > 0 ? (<>
							<h3>{cluster.label}</h3>
							{cluster.items.map((item)  => (
								<Stack className="leftSpacing1" direction="row" justifyContent="space-between" alignItems="center">
									<Typography gutterBottom variant="h6" component="div" style={{paddingLeft: "10px"}}>
										  {articles[item].label}																			
									</Typography>
								    <Typography gutterBottom variant="h6" component="div">
									   <nobr>	{formatNumber("de_DE", articles[item].price)}</nobr>
						          	</Typography>
								</Stack>
							))}
						</>):(<></>)}
					</>
				))}
				</>
	};


	function renderItems(id) {
		return 	<>	
				{internalConfiguration[id].cluster.map((cluster)  => (
					<>
						{cluster.items.length > 0 ? (<>
							{cluster.items.map((item)  => (
								<Stack className="leftSpacing1" direction="row" justifyContent="space-between" alignItems="center">
									<Typography gutterBottom variant="h6" component="div">
										  {articles[item].label} 																			
									</Typography>
								    <Typography gutterBottom variant="h6" component="div">
									   	<nobr>{formatNumber("de_DE", articles[item].price)}</nobr>
						          	</Typography>
								</Stack>
							))}
						</>):(<></>)}
					</>
				))}
				</>
	};
		

	
	function renderSmallSumUp(model) {

		let subtotal = Number(calcCluster(0)) + Number(calcCluster(1)) + Number(calcCluster(2)) + Number(calcCluster(3)) + Number(carPrice) ;
		let basePrice = Number(calcCluster(0)) + Number(carPrice);
		let discount = Number(basePrice) / 100 * model.discount;
		let finalPrice = subtotal - discount;		
				
		return <Paper className="stickyConfigurationSumUp" sx={{marginTop: "60px"}}>
					<Box>	
						<Box sx={{paddingLeft: "8px", backgroundColor: "rgb(43, 108, 176) !important",minHeight: "40px", lineHeight: "40px", color: "white"}}>
							{t("IhreAuswahl")}
						</Box>	
						<Box sx={{paddingLeft: "8px", paddingRight: "8px", paddingBottom: "8px"}}>
							<Box sx={{alignItems: "center"}}>	
								<center>
						      	<img height="120"
						        	 src={model.imagePlain}		        			
						      	/>	
								</center>
							</Box>	
					      	<hr/>
					      	
							<Accordion sx={{boxShadow1: "none"}}>
						        <AccordionSummary
						          expandIcon={<ExpandMoreIcon />}
						          aria-controls="panel1-content"
						          id="panel1-header"
						        >
   						        	<Box className="clearfix" sx={{width: "-webkit-fill-available"}}>
						        		<Stack className="leftSpacing1" direction="row" justifyContent="space-between" alignItems="center">
											<Typography gutterBottom variant="h6" component="div">
												{t("Basisfahrzeug")}<br/>{model.baseModel}<br/>{model.engines[0].slogan}
								 			</Typography>
								    		<Typography gutterBottom variant="h6" component="div">
									   			<nobr>&nbsp;{formatNumber("de_DE", carPrice)}</nobr>		
						          			</Typography>																			          
										</Stack>	
									    {model.discount && model.showDiscount == "true" ? (
							        		<Stack className="leftSpacing1" direction="row" justifyContent="space-between" alignItems="center">
												<Typography gutterBottom variant="h6" component="div">
													{t("Nachlass")}
									 			</Typography>
									    		<Typography gutterBottom variant="h6" component="div">
										        {model.discount && model.showDiscount == "true" ? (
													<>
										   			<nobr>&nbsp;-{formatNumber("de_DE", (carPrice /100 * model.discount))}</nobr>
										 		</>
											) :(<></>)
												}			
							          			</Typography>																			          
											</Stack>	
											) :(<></>)
										}			
									</Box>	
						        </AccordionSummary>
							</Accordion>					      	
							<Accordion sx={{boxShadow1: "none"}}>
						        <AccordionSummary
						          expandIcon={<ExpandMoreIcon />}
						          aria-controls="panel1-content"
						          id="panel1-header"
						        >
						        	<Box className="clearfix" sx={{width: "-webkit-fill-available"}}>
						        		<Stack className="leftSpacing1" direction="row" justifyContent="space-between" alignItems="center">
											<Typography gutterBottom variant="h6" component="div">
												{t("Sonderausstattung")}
								 			</Typography>
								    		<Typography gutterBottom variant="h6" component="div">
									   			<nobr>&nbsp;{formatNumber("de_DE", calcCluster(0))}</nobr>
						          			</Typography>																			          
										</Stack>
										{model.discount && model.showDiscount == "true" ? (
							        		<Stack className="leftSpacing1" direction="row" justifyContent="space-between" alignItems="center">
												<Typography gutterBottom variant="h6" component="div">
													{t("Nachlass")}
									 			</Typography>
									    		<Typography gutterBottom variant="h6" component="div">
												            {model.discount && model.showDiscount == "true" ? (
													<>
										   			<nobr>&nbsp;-{formatNumber("de_DE", (calcCluster(0) /100 * model.discount))}</nobr>
										 		</>
											) :(<></>)
												}			
							          			</Typography>																			          
											</Stack>									
										) :(<></>)
										}			
									</Box>	
						        </AccordionSummary>
						        <AccordionDetails>
							        {renderItems(0)}															        
						        </AccordionDetails>
							</Accordion>					      	
							<Accordion sx={{boxShadow1: "none"}}>
						        <AccordionSummary
						          expandIcon={<ExpandMoreIcon />}
						          aria-controls="panel1-content"
						          id="panel1-header"
						        >
						        	<Box className="clearfix" sx={{width: "-webkit-fill-available"}}>
						        		<Stack className="leftSpacing1" direction="row" justifyContent="space-between" alignItems="center">
											<Typography gutterBottom variant="h6" component="div">
												{t("Dach")}
								 			</Typography>
								    		<Typography gutterBottom variant="h6" component="div">
									   			<nobr>&nbsp;{formatNumber("de_DE", calcCluster(1))}</nobr>
						          			</Typography>																			          
										</Stack>
									</Box>	
						        </AccordionSummary>
						        <AccordionDetails>
							        {renderItems(1)}															        
						        </AccordionDetails>
							</Accordion>					      	
							<Accordion sx={{boxShadow1: "none"}}>
						        <AccordionSummary
						          expandIcon={<ExpandMoreIcon />}
						          aria-controls="panel1-content"
						          id="panel1-header"
						        >
						        	<Box className="clearfix" sx={{width: "-webkit-fill-available"}}>
						        		<Stack className="leftSpacing1" direction="row" justifyContent="space-between" alignItems="center">
											<Typography gutterBottom variant="h6" component="div">
												{t("Zubehör")}
								 			</Typography>
								    		<Typography gutterBottom variant="h6" component="div">
									   			<nobr>&nbsp;{formatNumber("de_DE", calcCluster(2))}</nobr>
						          			</Typography>																			          
										</Stack>	
									</Box>
						        </AccordionSummary>
						        <AccordionDetails>															        
							        {renderItems(2)}															        
						        </AccordionDetails>
							</Accordion>					      	
							<Accordion>
						        <AccordionSummary
						          expandIcon={<ExpandMoreIcon />}
						          aria-controls="panel1-content"
						          id="panel1-header"
						        >
						        	<Box className="clearfix" sx={{width: "-webkit-fill-available"}}>
						        		<Stack className="leftSpacing1" direction="row" justifyContent="space-between" alignItems="center">
											<Typography gutterBottom variant="h6" component="div">
												{t("Dekor")}
								 			</Typography>
								    		<Typography gutterBottom variant="h6" component="div">
									   			<nobr>&nbsp;{formatNumber("de_DE", calcCluster(3))}</nobr>
						          			</Typography>																			          
										</Stack>
									</Box>	
						        </AccordionSummary>
						        <AccordionDetails>															        
							        {renderItems(3)}															        
						        </AccordionDetails>
							</Accordion>					      	
						</Box>	
						<Box sx={{paddingLeft: "8px", paddingRight: "8px", backgroundColor: "rgb(237, 242, 247) !important",minHeight: "40px", lineHeight: "40px"}}>
					        <Stack className="leftSpacing1" direction="row" justifyContent="space-between" alignItems="center">
								<Typography gutterBottom variant="h6" component="div" sx={{lineHeight: "40px"}}>
									{t("Zwischensumme")}
							 	</Typography>
							    <Typography gutterBottom variant="h6" component="div"  sx={{lineHeight: "40px"}}>
								   	{formatNumber("de_DE",  subtotal) }
					          	</Typography>																			          
							</Stack>	
							
							{model.discount && model.showDiscount == "true" ? (
						        <Stack className="leftSpacing1" direction="row" justifyContent="space-between" alignItems="center">
									<Typography gutterBottom variant="h6" component="div" sx={{lineHeight: "40px"}}>
										{t("Nachlass")}
								 	</Typography>
								    <Typography gutterBottom variant="h6" component="div"  sx={{lineHeight: "40px"}}>
										{formatNumber("de_DE", discount)}
						          	</Typography>																			          
								</Stack>	

										) :(<></>)
							}			
							{model.discount && model.showDiscount == "true" ? (
						        <Stack className="leftSpacing1" direction="row" justifyContent="space-between" alignItems="center">
									<Typography gutterBottom variant="h6" component="div" sx={{lineHeight: "40px"}}>
										{t("Ihr Preis")}
								 	</Typography>
								    <Typography gutterBottom variant="h6" component="div"  sx={{lineHeight: "40px"}}>
										{formatNumber("de_DE", finalPrice)}
						          	</Typography>																			          
								</Stack>	

										) :(<></>)
							}			
					        <Stack className="leftSpacing1" direction="row" justifyContent="space-between" alignItems="center">
								<Typography gutterBottom variant="h6" component="div" sx={{lineHeight: "40px"}}>
									{t("zzglÜberführung")}
							 	</Typography>
							    <Typography gutterBottom variant="h6" component="div"  sx={{lineHeight: "40px"}}>
								   	{formatNumber("de_DE", model.transferCosts)}
					          	</Typography>																			          
							</Stack>	
					        <Stack className="leftSpacing1" direction="row" justifyContent="space-between" alignItems="center">
								<Typography gutterBottom variant="h6" component="div" sx={{lineHeight: "40px"}}>
									{t("Gesamtpreis")}
							 	</Typography>
							    <Typography gutterBottom variant="h6" component="div"  sx={{lineHeight: "40px"}}>
								   	{formatNumber("de_DE", finalPrice + parseFloat(model.transferCosts))}
					          	</Typography>																			          
							</Stack>	
						</Box>
					</Box>	
				</Paper>		
	}	
	
	
  	
  	return (<>
				{model != undefined ? (<>
				   			<Alert display={displayAlert} displayAlertMsg={displayAlertMsg} setDisplayAlert={setDisplayAlert}/>

				<Box sx={{ flexGrow: 1, display: {
							xs: 'block',
							sm: 'block',  
							md: 'block',  
							lg: 'block',  
							xl: 'block',  
							
							} }}
				>
	  				<Box sx={{paddingTop: "0px"}}> 
						<Header setLanguage={props.props.setLanguage} heroImages={model.heroImages} label={model.producerLabel  + " "+  model.label} slogan={t("KonfigureDescription")} breadcrumb={props.props.breadcrumb} embedded={props.props.embedded}/>

		  				<Box sx={{paddingTop: "0px"}}> 
				      		<Grid container style={{paddingTop: "0px",paddingLeft: "8px",paddingRight: "8px"}}>
				        		<Grid item xs={12}>
						      		<Grid container spacing={2}>
						        		<Grid item xs={0} sm={0} md={1} lg={2} xl={2}>
							     	   </Grid>
						        		<Grid item xs={12} sm={12} md={10} lg={8} xl={8}>
											<Box sx={{	marginTop: "30px", 
														backgroundColor: "#fff"
													}}
											>
												<Box  style={{textAlign: "left", color: "#000"}}>					
	      											<Stepper activeStep={activeStep}>
														{steps.map((label, index) => {
												        	const stepProps = {};
												          	const labelProps = {};
	          												if (isStepOptional(index)) {
																labelProps.optional = (
	              													<Typography variant="caption">Optional</Typography>
	            												);
	          												}
															if (isStepSkipped(index)) {
																stepProps.completed = false;
	          												}
	          												return (
																<Step key={label} {...stepProps} sx={{fontSize: "28px"}}>
																	<StepLabel {...labelProps} sx={{fontSize: "42px"}}>{label}</StepLabel>
																</Step>
	          												);
	        											})}
													</Stepper>
	 												{activeStep === steps.length ? (
	        											<React.Fragment>
	          												<Typography sx={{ mt: 2, mb: 1 }}>
																All steps completed - you&apos;re finished
	          												</Typography>
															<Box sx={{ display: 'flex', flexDirection: 'row', pt: 2 }}>
	            												<Box sx={{ flex: '1 1 auto' }} />
																	<Button onClick={handleReset}>Reset</Button>
																</Box>
	        											</React.Fragment>
	      											) : (													  
		        										<React.Fragment>
	 														{activeStep === 0 ? (
				          										<Box sx={{marginTop: "20px"}}>
																    <ReimoSwiper
																        height="760px"
																        slidesPerView={3}
																        spaceBetween={30}
																        loop={false}
																        resetOnChildrenChange={true}
																
																    >
					          											{model.engines.map((engine) => (
																	        	<SwiperSlide>
																					<ModelCard model={engine} handleNext={handleNext} setWhichConfiguration={setWhichConfiguration} whichConfiguration={whichConfiguration} changeConfiguration={changeConfiguration}  producer={model.producer} extCode={extCode} setExtCode={setExtCode} />
																	        	</SwiperSlide>
																	 	))}
																	 	{model.ownConfig == "true" ? (
																			<SwiperSlide>
																				<ModelCardOwnConfig model={model.engines[0]} label={model.ownConfigLabel} logo={model.producerLogo} whichConfiguration={whichConfiguration} changeConfiguration={changeConfiguration}  extCode={extCode} producer={model.producer} setExtCode={setExtCode} />
																        	</SwiperSlide>
																			) : (<></>)
																		}
																	</ReimoSwiper>	
																	
																	
																	
																		
	
																</Box>		          											
	
															):(<></>)}
															{activeStep === 1 ? (															
													      		<Grid container spacing={2}>
													        		<Grid item xs={0} sm={7} md={8} lg={8} xl={8}>
																		<Box sx={{marginTop: "20px"}}>
																			<center>
																				<h2>{t("Sonderausstattungen")}</h2>
																			</center>
																			
																			{model.configuration.extras.map((extras, index)  => (
																				<>
																					{widgetFactory(extras)}
																				</>
																			))}
																		</Box> 															        											
														     	   	</Grid>
													        		<Grid item xs={0} sm={5} md={4} lg={4} xl={4}>
																		{renderSmallSumUp(model)}		
														     	   	</Grid>
													     	   </Grid>
	
	
															):(<></>)}
															
															{activeStep === 2 ? (															
													      		<Grid container spacing={2}>
													        		<Grid item xs={0} sm={7} md={8} lg={8} xl={8}>
																		<Box sx={{marginTop: "20px"}}>
																			<center>
																				<h2>{t("Dachwählen")}</h2>
																			</center>
																			
																			{model.configuration.roof.map((roof, index)  => (
																				<>
																					{index == 0 ? (<>
																						<Grid container spacing={2}>
																						
																							{roof.items.map((mroof) => (
																								<Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
																								
																									<ProductRoofCard 	item={articles[mroof.refId]} 
																														changeItem={handleItem} 
																														uuid={roof.uuid} 
																														currentArtnr={mroof.refId} 																													
																														checked={isChecked(roof.uuid, mroof.refId)}
																									/>
																								
																								</Grid>
																							))}
																						</Grid>
																																								
																					</>) :(<>
																																									
																						{widgetFactory(roof)}
																						
																					</>)}																	
																				</>
																			))}
																		</Box> 															        											
														     	   	</Grid>
													        		<Grid item xs={0} sm={5} md={4} lg={4} xl={4}>
																		{renderSmallSumUp(model)}		
														     	   	</Grid>
													     	   </Grid>
	
	
															):(<></>)}
															{activeStep === 3 ? (
													      		<Grid container spacing={2}>
													        		<Grid item xs={0} sm={7} md={8} lg={8} xl={8}>
																		<Box sx={{marginTop: "20px"}}>
																			<center>
																				<h2>{t("Zubehörwählen")}</h2>
																			</center>
																			{model.configuration.equipment.map((obj)  => (
																				<>
																					{widgetFactory(obj)}
																				</>
																			))}
																		</Box>	          											
														     	   	</Grid>
													        		<Grid item xs={0} sm={5} md={4} lg={4} xl={4}>
																		{renderSmallSumUp(model)}		
														     	   	</Grid>
													     	   </Grid>
	
	
															):(<></>)}
															{activeStep === 4 ? (
													      		<Grid container spacing={2}>
													        		<Grid item xs={0} sm={7} md={8} lg={8} xl={8}>
																		<Box sx={{marginTop: "20px"}}>
																			<center>
																				<h2>{t("Dekorwählen")}</h2>
																			</center>
																			{model.configuration.decor.map((obj)  => (
																				<>
																					{widgetFactory(obj)}
																				</>
																			))}
			
																		</Box>	          											
														     	   	</Grid>
													        		<Grid item xs={0} sm={5} md={4} lg={4} xl={4}>
																		{renderSmallSumUp(model)}		
														     	   	</Grid>
													     	   </Grid>
	      											
	
															):(<></>)}
															{activeStep === 5 ? (
				          										<Box sx={{paddingTop: "20px"}}>
																	<Grid container>
																		<Grid item xs={12}>
																			<Grid container spacing={2}>
																				<Grid item xs={12} sm={12} md={7} lg={7} xl={7}>
									          										<Box >
									          											<center>
									          												<h2>{t("IhrReimoCamper")}</h2>
									          											</center>
									          											<Box sx={{position: "relative"}}>
									          												<Box style={{display: "flex", justifyContent: "flex-end"}}>
									          													<img src={carFinal}  width="400" style={{align: "right"}}/>
									          												</Box>
										          											<Box sx={{position: "absolute", top: "0px"}}>
										          												<Avatar sx={{width: "48px", height: "48px", border: "1px solid #000", backgroundColor: "#fff"}}  src={"/assets/article-images/" + returnSpecialValue(0, "exteriorColor")} />
										          												Außenfarbe
										          											</Box>
										          											<Box sx={{position: "absolute", top: "0px", left: "90px"}}>
										          												<Avatar sx={{width: "48px", height: "48px", border: "1px solid #000", backgroundColor: "#fff"}}  src={"/assets/article-images/" + returnSpecialValue(3, "furnitureDecor")} />
																								Möbeldekor
										          											</Box>
										          											<Box sx={{position: "absolute", top: "0px", left: "180px"}}>
										          												<Avatar sx={{width: "48px", height: "48px", border: "1px solid #000", backgroundColor: "#fff"}}  src={"/assets/article-images/" + returnSpecialValue(3, "basePlate")} />
																								Bodenplatte
										          											</Box>
										          											<Box sx={{position: "absolute", top: "0px", left: "270px"}}>
										          												<Avatar sx={{width: "48px", height: "48px", border: "1px solid #000", backgroundColor: "#fff"}}  src={"/assets/article-images/" + returnSpecialValue(3, "upholsteryFabric")} />
																								Stoffbezug
										          											</Box>
									          											</Box>
									          										</Box>
									          										<Paper sx={{padding: "20px", backgroundColor: "#eee"}}>
										          										<Box sx={{padding: "20px", backgroundColor: "#eee"}}>
																							<center>
																						   		<FormControl variant="standard"
																						      				sx={{marginBottom: "10px"}}>
																						        	<Input 	id="input-with-icon-adornment"
																						        			sx={{backgroundColor: "#fff"}}
																						          			disabled="true"
																						          			value={config}
																						         			endAdornment={
																							            		<InputAdornment position="end">
																							              			<ContentCopyIcon />
																							            		</InputAdornment>
																						          			}
																						        	/>
	            																				</FormControl>
	              																				<br/>
																								<Button onClick={e => callUrl("requestConfig")} 
																										endIcon={<SendIcon />}
																										variant="contained">
																										{t("KonfigurationperEmailschicken")}
																								</Button>																							
																							</center>
										          										</Box>	
									          										</Paper>
				          														</Grid>	
				          																	
				          																	
				          																											
																				<Grid item xs={12} sm={12} md={5} lg={5} xl={5} sx={{borderLeft: "1px solid #aaa"}}>
																					<Paper sx={{padding: "20px", marginBottom: "20px"}}>
																				        <Stack className="leftSpacing" direction="row" justifyContent="space-between" alignItems="center">
																				          	<Typography gutterBottom variant="h6" component="div">
																				            {t("Fahrzeugpreis")}:
																				          	</Typography>
																				          	<Typography gutterBottom variant="h6" component="div">
																					            <nobr>{formatNumber("de_DE", carPrice)}</nobr>
																				          	</Typography>																			          
																				        </Stack>		
																				        <Stack className="leftSpacing" direction="row" justifyContent="space-between" alignItems="center">
																				          <Typography gutterBottom variant="h6" component="div">
																				           {t("PreisReimoZusatzOptionen")}:
																				          </Typography>
																				          	<Typography gutterBottom variant="h6" component="div">
																					           <nobr>{formatNumber("de_DE", (calcCluster(0) + calcCluster(1) +calcCluster(2 +calcCluster(3))))}</nobr>
																				          	</Typography>																			          
																				        </Stack>
																				        <Stack className="leftSpacing" direction="row" justifyContent="space-between" alignItems="center">
																				          <Typography gutterBottom variant="h6" component="div">
																				            {t("Zwischensumme")}:
																				          </Typography>
																				          	<Typography gutterBottom variant="h6" component="div">
																					            <nobr>{formatNumber("de_DE",  Number(calcCluster(0)) + Number(calcCluster(1)) + Number(calcCluster(2)) + Number(calcCluster(3)) + Number(carPrice))}</nobr>
																				          	</Typography>																			          
																				        </Stack>
																				        <Stack className="leftSpacing" direction="row" justifyContent="space-between" alignItems="center">
																				          <Typography gutterBottom variant="h6" component="div">
																				            {t("Nachlass")}:
																				          </Typography>
																				          	<Typography gutterBottom variant="h6" component="div">
																					            <nobr>{formatNumber("de_DE",  (Number(calcCluster(0)) + Number(carPrice)) / 100 * model.discount)}</nobr>
																				          	</Typography>																			          
																				        </Stack>
																				        <Stack className="leftSpacing" direction="row" justifyContent="space-between" alignItems="center">
																				          <Typography gutterBottom variant="h6" component="div">
																				            {t("Ihr Preis")}:
																				          </Typography>
																				          	<Typography gutterBottom variant="h6" component="div">
																					            <nobr>{formatNumber("de_DE",  (Number(calcCluster(0)) + Number(calcCluster(1)) + Number(calcCluster(2)) + Number(calcCluster(3)) + Number(carPrice) - (Number(calcCluster(0)) + Number(carPrice)) / 100 * model.discount))}</nobr>
																				          	</Typography>																			          
																				        </Stack>
																				        <Stack className="leftSpacing" direction="row" justifyContent="space-between" alignItems="center">
																							<Typography gutterBottom variant="h6" component="div" sx={{lineHeight: "40px"}}>
																								{t("zzglÜberführung")}
																						 	</Typography>
																						    <Typography gutterBottom variant="h6" component="div"  sx={{lineHeight: "40px"}}>
																							   	{formatNumber("de_DE", model.transferCosts)}
																				          	</Typography>																			          
																						</Stack>																			        		
																				        <Stack className="leftSpacing" direction="row" justifyContent="space-between" alignItems="center">
																							<Typography gutterBottom variant="h6" component="div" sx={{lineHeight: "40px"}}>
																								{t("Gesamtpreis")}
																						 	</Typography>
																						    <Typography gutterBottom variant="h6" component="div"  sx={{lineHeight: "40px"}}>
																							   	{formatNumber("de_DE",  (Number(calcCluster(0)) + Number(calcCluster(1)) + Number(calcCluster(2)) + Number(calcCluster(3)) + Number(carPrice) - (Number(calcCluster(0)) + Number(carPrice)) / 100 * model.discount) + Number(model.transferCosts))}
																				          	</Typography>																			          
																						</Stack>																			        		
																					</Paper >
																																								
																					<Paper sx={{padding: "20px"}}>
																				        <Stack className="leftSpacing" direction="row" justifyContent="space-between" alignItems="center">
																				          <Typography gutterBottom variant="h6" component="div">
																				            {t("GerneSchickenWirIhnenEinUnverbindlichesAngebotZu")}:
																				          </Typography>
																				          																			          
																				        </Stack>		
																				        <Stack 	className="leftSpacing" 
																				        		direction="row" 
																				        		justifyContent="space-between"
																				        		sx={{flexDirection: "row-reverse"}}																			        		
																				        		alignItems="right">
																							<Button onClick={e => callUrl("requestOffer")}
																									endIcon={<ReceiptIcon />} 
																									variant="contained">{t("anfragen")}
																							</Button>
																				        </Stack>																			        		
																					</Paper >
	
	
																				</Grid>														
																			</Grid>														
																		</Grid>														
																	</Grid>	
																	<br/>
																	<Accordion>
																        <AccordionSummary
																          expandIcon={<ExpandMoreIcon />}
																          aria-controls="panel1-content"
																          id="panel1-header"
																        >
																        	<Box className="clearfix" sx={{width: "-webkit-fill-available"}}>
																        		<Stack className="leftSpacing1" direction="row" justifyContent="space-between" alignItems="center">
																					<Typography gutterBottom variant="h6" component="div">
																						{t("Basisfahrzeug")}&nbsp;{model.baseModel}
																		 			</Typography>
																		    		<Typography gutterBottom variant="h6" component="div" style={{paddingRight: "20px"}}>
																			   			<nobr>&nbsp;{formatNumber("de_DE", carPrice)}</nobr>
																          			</Typography>																			          
																				</Stack>
																			</Box>
																        </AccordionSummary>
	      															</Accordion>
	
																	<Accordion>
															        	<AccordionSummary
																          expandIcon={<ExpandMoreIcon />}
																          aria-controls="panel2-content"
																          id="panel2-header"
																        >
																        	<Box className="clearfix" sx={{width: "-webkit-fill-available"}}>
																        		<Stack className="leftSpacing1" direction="row" justifyContent="space-between" alignItems="center">
																					<Typography gutterBottom variant="h6" component="div">
																						{t("Sonderzubehör Basisfahrzeug")}
																		 			</Typography>
																		    		<Typography gutterBottom variant="h6" component="div" style={{paddingRight: "20px"}}>
																			   			<nobr>&nbsp;{formatNumber("de_DE", calcCluster(0))}</nobr>
																          			</Typography>																			          
																				</Stack>
																			</Box>															          	
															        </AccordionSummary>
															        <AccordionDetails>
																		{renderCluster(0)}
															        </AccordionDetails>
															      </Accordion>
																	<Accordion>
															        	<AccordionSummary
																          expandIcon={<ExpandMoreIcon />}
																          aria-controls="panel2-content"
																          id="panel2-header"
																        >
															        	<Box className="clearfix" sx={{width: "-webkit-fill-available"}}>
															        		<Stack className="leftSpacing1" direction="row" justifyContent="space-between" alignItems="center">
																				<Typography gutterBottom variant="h6" component="div">
																					{t("Dach")}
																	 			</Typography>
																	    		<Typography gutterBottom variant="h6" component="div" style={{paddingRight: "20px"}}>
																		   			<nobr>&nbsp;{formatNumber("de_DE", calcCluster(1))}</nobr>
															          			</Typography>																			          
																			</Stack>
																		</Box>														        
															        </AccordionSummary>
															        <AccordionDetails>
																		{renderCluster(1)}
															        </AccordionDetails>
															      </Accordion>
															      <Accordion>
															      	<AccordionSummary
															          expandIcon={<ExpandMoreIcon />}
															          aria-controls="panel3-content"
															          id="panel3-header"
															        >
															        	<Box className="clearfix" sx={{width: "-webkit-fill-available"}}>
															        		<Stack className="leftSpacing1" direction="row" justifyContent="space-between" alignItems="center">
																				<Typography gutterBottom variant="h6" component="div">
																					{t("Zubehör")}
																	 			</Typography>
																	    		<Typography gutterBottom variant="h6" component="div" style={{paddingRight: "20px"}}>
																		   			<nobr>&nbsp;{formatNumber("de_DE", calcCluster(2))}</nobr>
															          			</Typography>																			          
																			</Stack>
																		</Box>														        
															        														          	
															          	
															        </AccordionSummary>
															        <AccordionDetails>
																		{renderCluster(2)}
															        </AccordionDetails>
															      </Accordion>
	
															      <Accordion>
															      	<AccordionSummary
															          expandIcon={<ExpandMoreIcon />}
															          aria-controls="panel3-content"
															          id="panel3-header"
															        >
															        	<Box className="clearfix" sx={{width: "-webkit-fill-available"}}>
															        		<Stack className="leftSpacing1" direction="row" justifyContent="space-between" alignItems="center">
																				<Typography gutterBottom variant="h6" component="div">
																					{t("Dekor")}
																	 			</Typography>
																	    		<Typography gutterBottom variant="h6" component="div" style={{paddingRight: "20px"}}>
																		   			<nobr>&nbsp;{formatNumber("de_DE", calcCluster(3))}</nobr>
															          			</Typography>																			          
																			</Stack>
																		</Box>														        
															          	
															        </AccordionSummary>
															        <AccordionDetails>
																		{renderCluster(3)}
															        </AccordionDetails>
															      </Accordion>
	
																</Box>	          											
															):(<></>)}
	
															
															<Box sx={{ 	display: 'flex', 
																		flexDirection: 'row', 
																		pt: 2 
																	}}
															>
			            										<Button	variant="contained" 
										        						startIcon={<ArrowBackIosIcon />}
															            disabled={activeStep === 0}
															            onClick={handleBack}
															            sx={{ mr: 1 }}
															     >
			              											{t("back")}
			            										</Button>
			            										<Box sx={{ flex: '1 1 auto' }} />		
													              	{activeStep === steps.length - 1 ? 
													              		( <>
													              		 	  <Button onClick={handleReset}
													              		 	  		  variant="contained"
													              		 	  		  endIcon={<RestartAltIcon />}
													              		 	  		  sx=	{{	marginRight: "5px", 
																								display:{	xs: 'none',
																											sm: 'inline-flex',  
																											md: 'inline-flex',  
																											lg: 'inline-flex',  
																											xl: 'inline-flex',  							
																										}
																							}}
													              		 	  >
													              		 	  	{t("erneutStarten")}		  
													              		 	  </Button>
																			  <Button onClick={e => callUrl("requestConfig")} 
													              				 endIcon={<SendIcon />}
													              				 variant="contained"
													              			  >
													              				{t("KonfigurationperEmailschicken")}
													              		 	  </Button>
																		  </>																							
																		) : 												              	
													              		(<Button variant="contained" 
												        						 endIcon={<ArrowForwardIosIcon />}
																	             sx={{ mr: 1 }}onClick={handleNext}
																	     >
																         	{t("next")}
																	      </Button>
																	)}
													        </Box>
													        {activeStep === 0 ? (
																<>
														        <Box style={{marginLeft: "20px", marginTop: "10px"}}>
														        	{t("AngabenHinsichtlichWerten")}
														        </Box>
																</>
													        ):(<></>)}
												        </React.Fragment>
													)}
	
	
												</Box>			
											</Box>	
	
							     	   </Grid>
						        		<Grid item xs={0} sm={0} md={1} lg={2} xl={2}>
							     	   </Grid>
						     	   </Grid>
					     	   </Grid>
				     	   	</Grid>
	
			  				<Box sx={{paddingTop: "40px"}}> 
								<ContactPersons/>
							</Box>
						</Box>
					</Box>
					<RequestOffer open={requestOffer} handleOpen={setRequestOffer} config={config} car={props.props.model}/>
					<RequestConfig open={requestConfig} handleOpen={setRequestConfig}  car={props.props.model} userConfig={userConfig}/>
			      	<Backdrop
				        sx={{ color: '#fff', zIndex: 8000 }}
				        open={openBD}
				        onClick={handleCloseBD}
				      >
				        <CircularProgress color="inherit" />
				    </Backdrop>      			
	   				<DisplayImage display={displayImage}  setDisplayImage={setDisplayImage} item={item}/>

   			</Box>
   		</>):( <>
   			   </>)
   		}
)
   			
   		</>
   	)
}

export default function ConfigurePage(props) {

  return <ConfigureContent props={props}/>;
}